import { PageProvider } from '@/core/context/PageContext';
import { useTableFilter } from '@/core/hooks/useTableFilter';
import GetAllCityViewModel from '@/modules/city/viewmodels/city-get-all.viewmodel';
import GetAllListDistrictViewModel from '@/modules/district/viewmodels/district-get-all.viewmodel';
import React, { useEffect } from 'react';
import GetListWardViewModel from '../viewmodels/ward-list.viewmodel';

export const WardProvider = ({ children }: { children: React.ReactNode }) => {
  const { actionGetListWard, wardData, error, loading } = GetListWardViewModel();

  const { actionGetAllDistrict, districtData } = GetAllListDistrictViewModel();
  const { actionGetAllCity, cityData } = GetAllCityViewModel();

  const { methodFilter } = useTableFilter({
    handleFetchData: actionGetListWard,
    querySearch: { search: '' },
    queryFilters: { isActive: undefined },
    queryPagination: { page: 1, limit: 10 },
  });

  const { control, setValue, reset, getValues, watch } = methodFilter;

  const searchDistrict = async (search: string) => {
    await actionGetAllDistrict({
      search,
      isActive: true,
    });
  };

  const searchCity = async (search: string) => {
    await actionGetAllCity({
      search,
      isActive: true,
    });
  };

  useEffect(() => {
    actionGetListWard(getValues());
    actionGetAllDistrict();
    actionGetAllCity();
  }, []);

  const data = {
    wardData,
    actionGetListWard,
    searchDistrict,
    districtData,
    searchCity,
    cityData,
    error,
    loading,
    control,
    setValue,
    reset,
    getValues,
    watch,
  };

  return <PageProvider {...data}>{children}</PageProvider>;
};
